import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { getCartCurrency } from 'ducks/cart';
import routes, { routeFor } from 'helpers/routes';
import { ProductType } from 'types';
import { theme } from 'styles';

const StyledProductCard = styled(Link)`
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 6px;
  box-shadow: ${theme.boxShadow.small};
  background-color: ${theme.colors.white};
  width: 100%;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.navy};
  text-decoration: none;

  &:hover {
    box-shadow: ${theme.boxShadow.big};
  }
`;

const Image = styled.div`
  display: block;
  border-radius: 6px 6px 0px 0px;
  margin-bottom: ${theme.sp.s};
  background-color: ${theme.colors.white};
  background-size: 90%;
  background-position: center center;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  width: 100%;
  height: 160px;
`;

const DetailWrapper = styled.div`
  padding: 0px 20px 20px 20px;
`;

const Name = styled.div`
  height: 60px;
  line-height: 20px;
  color: ${theme.colors.navy};
`;

const Price = styled.div`
  margin-top: auto;
`;

const Cta = styled.div`
  color: ${theme.colors.white};
  background: ${theme.colors.blue};
  padding: 20px;
  border-radius: 0px 0px 6px 6px;
`;

const propTypes = {
  product: ProductType.isRequired,
  currency: PropTypes.string.isRequired,
};

const defaultProps = {};

function ProductCard(props) {
  const { product, currency } = props;
  return (
    <StyledProductCard
      to={routeFor(
        routes.products.show,
        product.productCategories[0].slug,
        product.slug,
      )}
    >
      <Image
        src={`${process.env.GATSBY_MARKETTAP_ASSET_HOST}${
          product.bannerImageUrl.thumbnail
        }`}
        alt={product.name}
      />
      <DetailWrapper>
        <Name>{product.name}</Name>
        <Price>{product.prices[currency].formattedPrice}</Price>
      </DetailWrapper>
      <Cta>View</Cta>
    </StyledProductCard>
  );
}

ProductCard.propTypes = propTypes;
ProductCard.defaultProps = defaultProps;

const mapStateToProps = state => ({
  currency: getCartCurrency(state),
});

export default connect(mapStateToProps)(ProductCard);



// WEBPACK FOOTER //
// ./src/components/shared/ProductCard/ProductCard.jsx